var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',_vm._l((_vm.derivedParams),function(derivedParam){return _c('v-col',{key:derivedParam.param_id,attrs:{"cols":"12","sm":"6","md":"3","lg":"3","xl":"3"}},[_c('DerivedParam',{attrs:{"derivedParam":derivedParam}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }